/**
 * EL VALOR EN LETRAS, QUE EN UNA COTIZACIÓN NO ES UN ADORNO.
 *
 * Va debajo del total en todos los documentos comerciales de MEGA porque es lo
 * que impide que un número se cambie después: un «289.629» se retoca con un
 * bolígrafo, «DOSCIENTOS OCHENTA Y NUEVE MIL SEISCIENTOS VEINTINUEVE» no.
 *
 * Se escribe aquí y no se trae una librería: son ochenta líneas, el castellano
 * de los números no cambia, y una dependencia más es una cosa más que puede
 * romperse en un documento que el cliente firma.
 */

const UNIDADES = [
  '', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE',
  'DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE',
  'DIECIOCHO', 'DIECINUEVE', 'VEINTE',
]

const DECENAS = [
  '', '', 'VEINTI', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA',
  'OCHENTA', 'NOVENTA',
]

const CENTENAS = [
  '', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS',
  'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS',
]

/** De 0 a 999. */
function hastaMil(n: number): string {
  if (n === 0) return ''
  if (n === 100) return 'CIEN'

  const c = Math.floor(n / 100)
  const resto = n % 100

  const cien = CENTENAS[c]
  let decena = ''

  if (resto <= 20) {
    decena = UNIDADES[resto]
  } else {
    const d = Math.floor(resto / 10)
    const u = resto % 10
    // El veintiuno va pegado —VEINTIUNO— y del treinta en adelante con «y».
    decena = d === 2 ? `${DECENAS[2]}${UNIDADES[u].toLowerCase()}`.toUpperCase() : DECENAS[d]
    if (d > 2 && u > 0) decena += ` Y ${UNIDADES[u]}`
  }

  return [cien, decena].filter(Boolean).join(' ')
}

/**
 * El número escrito, como lo pone World Office: en mayúsculas y terminado en
 * «PESOS M/CTE». Los centavos no se dicen: estos documentos van en pesos
 * enteros.
 */
export function enLetras(valor: number | null | undefined): string {
  const n = Math.round(Math.abs(valor ?? 0))

  if (n === 0) return 'CERO PESOS M/CTE'

  const millones = Math.floor(n / 1_000_000)
  const miles = Math.floor((n % 1_000_000) / 1000)
  const resto = n % 1000

  const partes: string[] = []

  if (millones === 1) partes.push('UN MILLÓN')
  else if (millones > 1) partes.push(`${hastaMil(millones)} MILLONES`)

  // «UN MIL» no se dice: es MIL a secas.
  if (miles === 1) partes.push('MIL')
  else if (miles > 1) partes.push(`${hastaMil(miles)} MIL`)

  if (resto > 0) partes.push(hastaMil(resto))

  return `${partes.join(' ')} PESOS M/CTE`
}
